import { VehicleLocation } from 'server'

export const vehicleIsActive = (timestamp: string): boolean => {
  const diff = Date.now() - new Date(timestamp).getTime()
  const oneDayInMilliseconds = 1000 * 60 * 60 * 24
  return diff < oneDayInMilliseconds
}

export const getActiveVehicles = (vehicleLocations: VehicleLocation) => {
  return vehicleLocations.filter((vehicleLocation: any) => {
    return vehicleIsActive(vehicleLocation.update_received)
  }).length
}
